import { TriangleAlertIcon } from 'lucide-react';

import { EmptyState } from '@/shared/components/EmptyState';

import type { BuildBoardResult } from '../boardModel';

// There is deliberately no "no backlog step" case: every workflow has a start
// step, so a board always has somewhere for a task to begin.
const REASON_COPY: Record<
  Extract<BuildBoardResult, { ok: false }>['reason'],
  string
> = {
  'no-workable-steps':
    'This workflow declares no AI Step or Human Gate, so there is no board to show. Fix the workflow definition to add at least one.',
};

export interface BoardUnavailableProps {
  reason: Extract<BuildBoardResult, { ok: false }>['reason'];
}

/**
 * Shown instead of an empty or broken column set when a workflow's shape
 * cannot be rendered as a board (spec FR-012). Typographic with a line-art
 * icon per the brand rules — no illustration.
 */
export function BoardUnavailable({ reason }: BoardUnavailableProps) {
  return (
    <EmptyState
      icon={TriangleAlertIcon}
      description={
        <>
          <span className="text-foreground block text-sm font-medium">
            Board unavailable
          </span>
          {REASON_COPY[reason]}
        </>
      }
    />
  );
}
